import React, { useEffect, useState } from "react"
import { REACT_APP_VAM_ENDPOINT, REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_CONTEXT_QC, REACT_APP_VAM_CONTEXT_SURVEYOR, REACT_APP_VAM_CONTEXT_FIELD } from "../urls";
import DatePicker from 'react-datepicker';
import { format, formatDistance } from "date-fns";
import Select from 'react-select';
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import TextTruncate from "../utilsComponent/textTruncate";
import { editModeOn, getFromDecreaptLocalStorage, validateDecimslInput } from "../utilFunctions";
import LoadingPage from "../reusableComponents/loader/loadingPage";
import { axiosRequest } from "../service";
import { getVendorsList } from "./vendorMaster/helper";
import { functionalities } from "../consts";
const QcSurvey = (props) => {
    const [loading, setLoading] = useState(false)
    const { claimDetailCookie,getClaimDetails, fieldSurveyId, roleDataCookie, getFieldSurveyData, fielSurveyData, getFieldSurveyLists, setFieldSurveyData } = props
    const [showRequest, setShowRequest] = useState(false)
    const [qcList, setQcList] = useState([])
    const navigate = useNavigate();
    const [vendorsList, setVendorsList] = useState([])
    const [surveyorsList, setSurveyorsList] = useState([])
    const [reviewRequestList, setReviewRequestList] = useState([])
    const [qCExecutiveList, setQCExecutiveList] = useState([])
    const policyDetailCookie = getFromDecreaptLocalStorage("policyDetail")
    const [approvalFlow, setApprovalFlow] = useState(false)
    const [showQcExecutiveModel, setShowQcExecutiveModel] = useState(false)
    const [selectedQcExecutive, setSelectedQcExecutive] = useState("")
    const [qcAssignLoading, setQcAssignLoading] = useState(false)
    const [qcPayload, setQcPayload] = useState({
        // fieldSurveyID: fieldSurveyId,
        claimNo: claimDetailCookie?.claimNo,
        qcvendorName: claimDetailCookie?.vendor,
        qcName: claimDetailCookie?.qcExecutive,
        qcCreatedBy: roleDataCookie?.userID,
        affectedArea: "",
        lossPercentage: "",
        harvestDate: "",
        reason: "",
        remarks: "",
        qcExecutive: "",
        qcSurveys: [{
                vendorId: "",
                vendorName: "",
                surveyorID: "",
                surveyorName: "",
            }]
    })
 
    useEffect(() => {
        if(fieldSurveyId){
            getQcList();
            getVendorsList(setVendorsList)
            getQcExecutiveList()
        }
    },[fieldSurveyId])
 
 
    const getQcList = () => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_QC}/getQCbySurveyID?surveyID=${fieldSurveyId}`)
            .then(data => {
                setQcList(data.data)
            }).catch(error => {
                console.log(error)
            })
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_QC}/getQCReviewRequestBySurveyID?surveyID=${fieldSurveyId}`)
            .then(data => {
                setReviewRequestList(data.data)
            }).catch(error => {
                console.log(error)
            })
    }
    const getQcExecutiveList = () => {
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/roles/QC_EXECUTIVE`)
        .then(data => {
        const formattedData = data.data.map((lead) => ({
            value: lead,
            label: lead,
        }));
 
        setQCExecutiveList(formattedData);
 
        //setQCleadList()
        }).catch(error => {
            console.log(error)
    })
    }
    const getSurveyorList = (vendorId) =>{
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}/getSurveyorAndQCMasterList/${vendorId}`)
           .then(data => {
              const formattedData = data.data.map((lead) => ({
                value: lead.surveyorId,
                label: lead.firstName + " " + lead.lastName,
              }));
     
              setSurveyorsList(formattedData);
     
              //setQCleadList()
            }).catch(error => {
                console.log(error)
         })
      }
 
    const approveQc = (e,url, approve) => {
        e.preventDefault();
        e.stopPropagation();
        if(validationQcFields(approve)){
            if(approve && (qcPayload?.remarks?.trim()==="")){
                toast.error("Please Enter Remarks")
                return
            }
            setLoading(true);
            axiosRequest().post(url, {...qcPayload, fieldSurveyID: fieldSurveyId})
                .then(data => {
                    approve ? toast.success("QC has been Approved Successfully.") : toast.success("QC has been Requested for More Info.")
                    setShowRequest(false)
                    // if(approve){
                    //     axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_CALCULATE}/calculateClaim`, {
                    //         "claimNo": claimDetailCookie?.claimNo,
                    //         "affectedArea": qcPayload.affectedArea,
                    //         "lossPercentage": qcPayload.lossPercentage,
                    //         "createdBy": roleDataCookie?.userID,
                    //          "calcType" : "FS"
                    //     }).then(res => {
                    //         // navigate(`/dashboard/claim_processing/claim_calculation`)
                    //     }).catch(error => {
                    //         console.log(error)
                    //     })
                    // }
                    getFieldSurveyData(fieldSurveyId,setFieldSurveyData)
                    getFieldSurveyLists()
                    getQcList()
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    setLoading(false)
                })
        }
    }
    const hanldeDatechange = (date) => {
        if (date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const dat1 = (date.getDate()).toString().padStart(2, '0')
            setQcPayload({ ...qcPayload, harvestDate: `${year}-${month}-${dat1} 00:00:00` })
        }
    }
    const validationQcFields = (approve) => {
        if(!qcPayload.qcvendorName){
            toast.error("Please Enter QC Vendor Name")
            return false
        }else if(!qcPayload.qcName){
            toast.error("Please Enter QC Checker Name ")
            return false
        }else if(!qcPayload.affectedArea && approve){
            toast.error("Please Enter Affected Area")
            return false
        }else if(!qcPayload.lossPercentage && approve){
            toast.error("Please Enter Loss Percentage")
            return false
        }else if(Number(qcPayload.lossPercentage) > 100){
            toast.error("Loss Percentage Can't be More Than 100.")
            return false
        }else {
            return true
        }
    }
    const assignQcExecutive = () => {
        if(!selectedQcExecutive){
            toast.error("Please Select QC Executive.")
            return
        }
        setQcAssignLoading(true)
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_FIELD}/assignQualityCheck`, {
            "qcExecutive": selectedQcExecutive,
            "surveyNumber": fieldSurveyId,
            "createdBy": roleDataCookie.userID,
        })
        .then(data => {
            setSelectedQcExecutive("")
            if(data.data === "Unable to assign QC Executive"){
                toast.error(data.data)
            }else{
                getClaimDetails(claimDetailCookie.claimNo)
                setQcPayload({...qcPayload, qcName: selectedQcExecutive})
                toast.success(data.data)
            }
            setShowQcExecutiveModel(false)
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setQcAssignLoading(false)
        })
    }
   
    return (
        <>
        {loading && (<LoadingPage kshemaLoader />)}  
        {
            qcList && qcList.length > 0 && qcList.map(list => (
            <>
                <div className="field_detail_headerFieldAdditonal">
                    <div className="field-idField">Survey QC</div>
                    <div className="field-statusField">{fielSurveyData.qcStatus}</div>
                </div>
                <div className="container-fluid align-result-tableField">
                    <div id="result-table-rowField" className="row">
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Affected Area
                            </div>
                            <div className="query-answerField">
                                {list.affectedArea} 
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Loss %
                            </div>
                            <div className="query-answerField">
                                {list.lossPercentage}%
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Harvested Date
                            </div>
                            <div className="query-answerField">
                               {list?.harvestDate ? format(new Date(list.harvestDate), 'dd-MM-yyyy, hh:mm a') : "--"}
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Quality Checker Name
                            </div>
                            <div className="query-answerField">
                                {<TextTruncate text={list.qcName} length={17}/>}
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                QC Initiated Date
                            </div>
                            <div className="query-answerField">
                                {list?.qcinitiatedDate ? format(new Date(list.qcinitiatedDate), 'dd-MM-yyyy, hh:mm a') : "--"}
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                QC Completed Date
                            </div>
                            <div className="query-answerField">
                               {list?.qcclosedDate ? format(new Date(list?.qcclosedDate), 'dd-MM-yyyy, hh:mm a') : "--"}
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Aging
                            </div>
                            <div className="query-answerField">
                            {list.qcclosedDate ? formatDistance(new Date(list.qcinitiatedDate), new Date(list.qcclosedDate)) : formatDistance(new Date(list.qcinitiatedDate), new Date())}
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Reason for More Info Request
                            </div>
                            <div className="query-answerField">
                                {list.reason ? list.reason : "--"}
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Remarks
                            </div>
                            <div className="query-answerField">
                                {list.remarks ? list.remarks : "--"}
                            </div>
                        </div>
                    </div>
                </div>  
                  {  list.qcSurveys && list.qcSurveys.length > 0 && list.qcSurveys.map(addtionalList => (
                       <>
                       <div className="field_detail_headerFieldAdditonal">
                           <div className="field-idField">Additional Info Response</div>
                           <div className="field-statusField"></div>
                           {/* <!-- current status is shown for the gis-status --> */}
                       </div>
                       <div className="container-fluid align-result-tableField">
                           <div id="result-table-rowField" className="row">
                               <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                   <div className="query-headingField">
                                       Additional Info Remarks by Surveyor
                                   </div>
                                   <div className="query-answerField">
                                       {addtionalList.surveyorRemarks ? addtionalList.surveyorRemarks : "--"}
                                   </div>
                               </div>
                               <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                   <div className="query-headingField">
                                       Vendor Name
                                   </div>
                                   <div className="query-answerField">
                                       {addtionalList.vendorName}
                                   </div>
                               </div>
                               <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                   <div className="query-headingField">
                                       Surveyor Name
                                   </div>
                                   <div className="query-answerField">
                                   {addtionalList.surveyorName}
                                   </div>
                               </div>
                               <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                   <div className="query-headingField">
                                       Request Initiated Date
                                   </div>
                                   <div className="query-answerField">
                                       {addtionalList.surveyIntiatedDate ? format(new Date(addtionalList.surveyIntiatedDate), 'dd-MM-yyyy, hh:mm a') : "--"}
                                   </div>
                               </div>
                               <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                   <div className="query-headingField">
                                       Response Received Date
                                   </div>
                                   <div className="query-answerField">
                                   {addtionalList.surveyCompletedDate ? format(new Date(addtionalList.surveyCompletedDate), 'dd-MM-yyyy, hh:mm a') : "--"}
                                   </div>
                               </div>
                               <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                   <div className="query-headingField">
                                       Aging
                                   </div>
                                   <div className="query-answerField">
                                       {addtionalList.surveyCompletedDate ? formatDistance(new Date(addtionalList.surveyIntiatedDate), new Date(addtionalList.surveyCompletedDate)) : formatDistance(new Date(addtionalList.surveyIntiatedDate), new Date())}
                                   </div>
                               </div>
                               {/* {
                                (addtionalList.lossAffectedAreaPhoto || addtionalList.neighbourFieldPhotos || addtionalList.neighbourFieldPhotos) && (
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <div class="query-headingField">
                                            Documents
                                        </div>
                                        <div class="row">
                                            {
                                                addtionalList.lossAffectedAreaPhoto && (
                                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                        <div class="align1_dataField survey_box1Field">
                                                            <div class="survey_box2Field">
                                                                <div class="uploaded_imgField">
                                                                    <img src={addtionalList.lossAffectedAreaPhoto} height="110px" width="100%" class="center-imgField" />
                                                                </div>
                                                            </div>
                                                            <div class="img_descriptionField">Loss Affected Area Photo <span class="asteriskField"></span></div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                addtionalList.neighbourFieldPhotos && (
                                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                        <div class="align1_dataField survey_box1Field">
                                                            <div class="survey_box2Field">
                                                                <div class="uploaded_imgField">
                                                                    <img src={addtionalList.neighbourFieldPhotos} height="110px" width="100%" class="center-imgField" style={{ borderRadius: "8px" }} />
                                                                </div>
                                                            </div>
                                                            <div class="img_descriptionField">Neighbour Field Photos <span class="asteriskField"></span></div>
                                                        </div>
                                                    </div>
 
                                                )
                                            }
                                            {
                                                addtionalList.farmerPhotoID && (
                                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                        <div class="align1_dataField survey_box1Field">
                                                            <div class="survey_box2Field">
                                                                <div class="uploaded_imgField">
                                                                    <img src={addtionalList.farmerPhotoID} height="110px" width="100%" class="center-imgField" style={{ borderRadius: "8px" }} />
                                                                </div>
                                                            </div>
                                                            <div class="img_descriptionField">Farmer Photo ID (Aadhar) <span class="asteriskField"></span></div>
                                                        </div>
                                                </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                )
                               } */}
                           </div>
                       </div>                        
                       </>
                  )) }
            </>
            ))
        }
        {
            reviewRequestList && reviewRequestList.length ? reviewRequestList.map(list => (
            <>
                <div className="field_detail_headerFieldAdditonal">
                            <div className="field-idField">QC Review Request</div>
                            {/* <div class="field-statusField">Status</div> */}
                        </div>  
                        <div className="container-fluid align-result-tableField">
                            <div id="result-table-rowField" className="row">
                                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                    <div className="query-headingField">
                                        Review Initiated Date
                                    </div>
                                    <div className="query-answerField">
                                    {format(new Date(list.reviewInitDate), 'dd-MM-yyyy, hh:mm a')}
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-5 col-sm-7">
                                    <div className="query-headingField">
                                    Handler Name
                                    </div>
                                    <div className="query-answerField">
                                     {list.handlerName}
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                    <div className="query-headingField">
                                        Remarks
                                    </div>
                                    <div className="query-answerField">
                                       {list.remarks}
                                    </div>
                                </div>
                            </div>
                        </div>          
            </>
            )) : null
        }
        {
            fielSurveyData.qcStatus!=="Requested Info" && fielSurveyData.qcStatus!=="Completed" && (fielSurveyData?.surveyStatus == "COMPLETED" || fielSurveyData?.surveyStatus == "CLOSED") && (
              <>
                <div className="field_detail_headerFieldQC">
                    <div className="field-idField">Survey QC</div>
                    <div className="field-statusField">In Progress</div>
                    {/* <!-- current status is shown for the gis-status --> */}
                </div>
                <div className="container-fluid align-result-tableField">
                    <div id="result-table-rowField" className="row">
                        <div className="col-xl-1_Field col-lg-1_Field col-md-4 col-sm-6">
                            <div className="query-headingField">
                                QC Vendor Name
                            </div>
                            <div className="query-answerField">
                                <input type="text" disabled id="affected_area" placeholder="Ex. Jayram Thakur" value={claimDetailCookie?.vendor || fielSurveyData?.jsonResponse?.vendorName} />
                            </div>
                        </div>
                        <div className="col-xl-1_Field col-lg-1_Field col-md-4 col-sm-6">
                            <div className="query-headingField">
                                QC Checker Name
                            </div>
                            <div className="query-answerField">
                                {claimDetailCookie?.qcExecutive ? <><input type="text" disabled id="affected_area" placeholder="Ex. Jayram Thakur" value={claimDetailCookie?.qcExecutive} />{editModeOn(functionalities.QC_ASSIGNMENT) && <Link className="assign-link text-primary" onClick={() => setShowQcExecutiveModel(true)}>Re Assign</Link>}</> : editModeOn(functionalities.QC_ASSIGNMENT) && <Link className="assign-link text-primary" onClick={() => setShowQcExecutiveModel(true)}>Assign</Link>}  
                            </div>
                        </div>
                        <div className="col-xl-1_Field col-lg-1_Field col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Affected Area
                            </div>
                            <div className="query-answerField">
                                <input type="text" id="affected_area" placeholder="Ex:1.5Acre" onChange={(e) => {
                                    if(Number(e.target.value)>policyDetailCookie.cultivated_area){
                                        toast.error("Affected area should be less than or equal to cultivated area.")
                                        const nonNumericValue = e.target.value.replace(/[0-9]/g, '');
                                        e.target.value = nonNumericValue;
                                        setQcPayload({ ...qcPayload, affectedArea: validateDecimslInput(e)})  
                                    }
                                    else{
                                        const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                        e.target.value = numericValue;
                                        setQcPayload({ ...qcPayload, affectedArea: validateDecimslInput(e)})  
                                    }}}
                                    value={qcPayload.affectedArea}
                                />
                            </div>
                        </div>
                        <div className="col-xl-1_Field col-lg-1_Field col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Loss %
                            </div>
                            <div className="query-answerField">
                                <input type="text" id="affected_area" value={qcPayload.lossPercentage} placeholder="Ex:15%" onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                    e.target.value = numericValue;
                                    setQcPayload({ ...qcPayload, lossPercentage: validateDecimslInput(e) })
                                    }} />
                            </div>
                        </div>
                        <div className="col-xl-1_Field col-lg-1_Field col-md-4 col-sm-6">
                            <div className="query-headingField">
                                Harvest Date
                            </div>
                            <div className="query-answerField">
                                <DatePicker
                                    selected={qcPayload?.harvestDate && new Date(qcPayload.harvestDate)}
                                    // className="align4_dataPolicy"
                                    onChange={hanldeDatechange}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="dd-mm-yyyy"
                                    // maxDate={new Date()}
                                    highlightDates={new Date()}
                                    onKeyDown={(e) => e.preventDefault()}
                                    showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div onClick={() => setShowRequest(true)} class="holdField">Request for More Info</div> */}
                {/* {
                    claimDetailCookie?.qcExecutive && claimDetailCookie?.claimStatus?.toLowerCase() !== "closed" && (
                        <div onClick={() => {if(validationQcFields()){
                            setShowRequest(true)
                        }}} class="holdField">Request for More Info</div>
                    )
                } */}
                {showRequest && (<div id="overlay1Field">
                    <div className="overlay_textField"><span onclick="off1()" className="xField glyphicon glyphicon-remove"></span></div>
                    {/* <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                <div class="align_overlay2Field">
                                    Vendor <span class="asteriskField"></span>
                                </div>
                                <Select id="exampleInputPassword2" options={vendorsList}
                                    classNamePrefix="align_data_overlay2Field" placeholder="Select Vendor"
                                    value={qcPayload.qcSurveys[0].vendorName ? {label: qcPayload.qcSurveys[0].vendorName} : { label: "Select Vendor", value: "Select Vendor" }}
                                    onChange={(data) => {
                                        setQcPayload({...qcPayload,qcSurveys:[{...qcPayload.qcSurveys[0], "vendorId" : data.value, "vendorName": data.label}]})
                                        ;getSurveyorList(data.value)
                                    }}
                                />
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                <div class="align_overlay2Field">
                                    Surveyor
                                </div>
                                <Select id="exampleInputPassword2" options={surveyorsList}
                                    classNamePrefix="align_data_overlay2Field" placeholder="Select Surveyor"
                                    value={qcPayload.qcSurveys[0].surveyorName ? {label: qcPayload.qcSurveys[0].surveyorName} : { label: "Select Surveyor", value: "Select Surveyor" }}
                                    onChange={(data) => {
                                        setQcPayload({...qcPayload,qcSurveys:[{...qcPayload.qcSurveys[0], "surveyorID" : data.value, "surveyorName": data.label}]})
                                    }}
                                />
                            </div>
                        </div>
                    </div> */}
                    {/* <div class="align_overlayField mx-4">QC Executive <span class="asteriskField"></span></div> */}
                    {/* <Select id="exampleInputPassword2" options={qCExecutiveList}
                                    classNamePrefix="align_data_overlayField" placeholder="Select the Reason"
                                    className="mx-4"
                                    value={qcPayload.qcExecutive ? {label: qcPayload.qcExecutive} : { label: "Select QC Executive"}}
                                    onChange={(data) => {
                                        setQcPayload({...qcPayload,qcExecutive: data.value})
                                    }}
                        /> */}
                    {
                        !approvalFlow && (
                          <>
                          <div className="align_overlayField mx-4">Request for More Info <span className="asteriskField"></span></div>
                          <Select id="exampleInputPassword2" options={[{label: "Incomplete Govt Official Info", value: "Incomplete Govt Official Info"},{label: "Mismatch with GIS data", value: "Mismatch with GIS data"}]}
                                          classNamePrefix="align_data_overlayField" placeholder="Select the Reason"
                                          className="mx-4"
                                          value={qcPayload.reason ? {label: qcPayload.reason} : { label: "Select the Reason", value: "Select the Reason" }}
                                          onChange={(data) => {
                                              setQcPayload({...qcPayload,reason: data.value})
                                          }}
                              />                        
                          </>
                        )
                    }
                    {/* <select class="align_data_overlayField">
                        <option value="" selected disabled hidden>Select the Reasons</option>
                        <option></option>
                        <option></option>
                    </select> */}
                    <div className="align_overlayField">Remarks <span className="asteriskField"></span></div>
                    <div><textarea
                        type="text"
                        id="reasonField"  
                        value={qcPayload.remarks}
                            onChange={(data) => {
                                setQcPayload({...qcPayload,remarks: data.target.value})
                            }}></textarea></div>
                    <div className="text-center mt-2">
                    <button className = "backField" onClick={() => { setShowRequest(false) }}>Cancel</button>
                    {
                      (editModeOn(functionalities.QC_DECISION) && approvalFlow) ?  <div className = "submit-1Field" disabled={qcPayload.reason==""}  onClick={(e) => approveQc(e,`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_QC}/aprrove`, true)}>Submit</div> : editModeOn(functionalities.QC_DECISION) && <button className = "submit-1Field" disabled={qcPayload.remarks==""  ||qcPayload.reason==""} onClick={(e) => approveQc(e,`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_QC}/requestinfo`)}>Submit</button>
                    }
                    </div>
                </div>)}
                {
                    claimDetailCookie?.qcExecutive && claimDetailCookie?.claimStatus?.toLowerCase() !== "closed" && editModeOn(functionalities.QC_DECISION) && (
                        <div onClick={() => {if(validationQcFields(true)){
                            setApprovalFlow(true)
                            setShowRequest(true)
                        }}}  className="approveField" style={{marginLeft: "40%"}}>Approve</div>
                    )
                }
                <div id="overlay2Field">
                    <div className="overlay_textField"><span onclick="off2()" className="xField glyphicon glyphicon-remove"></span></div>
                    <div className="align_overlayField">Remarks <span className="asteriskField"></span></div>
                    <div><textarea type="text" id="reasonField"></textarea></div>
                    <div className="backField">Cancel</div>
                    <div className="submit-1Field">Submit</div>
                </div>
                {/* approveQc(e,`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_QC}/aprrove`, true)} */}
              </>
            )
        }
          {
                showQcExecutiveModel && <>
                    <div id="overlay3Calc">
                        {
                          qcAssignLoading ? (
                            <LoadingPage/>
                          ) : (
                            <>
                                <div className="overlay_textCalc d-flex justify-content-end me-3 m-0"><span type="button" onClick={() => setShowQcExecutiveModel(false)} className="close" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></span></div>
                                <p className="align_overlay_handlerCalc">QC Executive Name <span className="asteriskCalc"></span></p>
                                <div>
                                    <Select id="exampleInputPassword2" options={qCExecutiveList}
                                            classNamePrefix="align_data_overlayField" placeholder="Select the Reason"
                                            className="mx-4"
                                            value={selectedQcExecutive ? {label: selectedQcExecutive} : { label: "Select QC Executive"}}
                                            onChange={(data) => {
                                                setSelectedQcExecutive(data.value)
                                            }}
                                />
                                </div>
                                <div className="back1Calc" onClick={() => setShowQcExecutiveModel(false)}>Cancel</div>
                                <div className="submit-3Calc" onClick={() => assignQcExecutive()}>Submit</div>                          
                            </>
                          )
                        }
                    </div>                
                </>
 
            }
        </>
    )
};
 
export default QcSurvey;